class squatDrawing {
	checkIfInSpace(inSquatCheck, squatInSpace){
		squatInSpace = false;
		if ( inSquatCheck['lowestpointX'] > inSquatCheck['leftSideOfSpace'] && inSquatCheck['lowestpointX'] < inSquatCheck['rightSideOfSpace'] && inSquatCheck['lowest_point'] > inSquatCheck['topSide'] && inSquatCheck['lowest_point'] < inSquatCheck['bottomSide'] )
			{
				squatInSpace = true;
			}
		
		return squatInSpace;
	}
}

export default squatDrawing;